import React from 'react';
import { useSelector } from 'react-redux';
import { GridItem } from '../GridItem';
import { ThumbnailInLoadingState } from '../../GameThumbnails/ThumbnailInLoadingState';

export const WinnersLoadingInGrid = () => {
    const { showWinnerTicker } = useSelector((state) => state.app.config);

    if (!showWinnerTicker) {
        return null;
    }

    return (
        <>
            <GridItem className="casino-vertical-grid__item--winner">
                <ThumbnailInLoadingState iconName="winner" />
            </GridItem>
            <GridItem className="casino-vertical-grid__item--winner">
                <ThumbnailInLoadingState iconName="winner" />
            </GridItem>
            <GridItem className="casino-vertical-grid__item--winner">
                <ThumbnailInLoadingState iconName="winner" />
            </GridItem>
        </>
    );
};
